import {useEffect} from 'react'
import {ChordAnalytics} from '@chordcommerce/analytics'
import {
    getChordDomain,
    getChordOmsId,
    getChordStoreId,
    getChordTenentId,
    getChordWriteKey
} from './utils'
import {
    cartFormatter,
    checkoutStartedFormatter,
    productAddedFormatter
} from './utils/cord-formatter'

let chordInstance = null

export const getChordInstance = () => chordInstance

const ChordInitializer = () => {
    useEffect(() => {
        const writeKey = getChordWriteKey()
        const apiHost = getChordDomain()
        const tenantId = getChordTenentId()
        const storeId = getChordStoreId()
        const omsId = getChordOmsId()

        if (
            !chordInstance &&
            writeKey &&
            apiHost &&
            tenantId &&
            storeId &&
            omsId
        ) {
            chordInstance = new ChordAnalytics({
                cdpWriteKey: writeKey,
                cdpDomain: apiHost,
                debug: true,
                enableLogging: true,
                formatters: {
                    events: {
                        'Product Added': productAddedFormatter,
                        'Checkout Started': checkoutStartedFormatter
                    },
                    objects: {
                        cart: cartFormatter
                    }
                },
                integrations: {
                    Chord: {
                        tenantId,
                        storeId,
                        omsId
                    }
                }
            })
        }
    }, [])

    return null
}

export default ChordInitializer
